export default __webpack_public_path__ + "static/media/26.073b2e33.jpeg";